export default __webpack_public_path__ + "src/image/dronecan_logo.png";